import { color } from 'framer-motion';
import { css } from 'styled-system/css';

export const tutorialParlayStyle = {
	text: css({
		mt: '6px',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: '18px',
	}),
	ul: css({
		listStyle: 'disc',
		ml: '20px',
	}),
	page1Label1: css({
		position: 'absolute',
		top: '21px',
		left: '41',
		display: 'flex',
		md: {
			display: 'none',
		},
		'& svg': {
			flex: 'none',
			left: '-14px',
			position: 'relative',
		},
		'& span': {
			flex: 'none',
			transform: 'scale(0.71)',
			color: 'whiteOpacity.100',
		},
	}),
	page1Label2: css({
		position: 'absolute',
		top: '20px',
		right: '58px',
		transform: 'scale(0.71)',
		transformOrigin: 'right',
		display: 'flex',
		md: {
			display: 'none',
		},
		'& svg': {
			width: '24px',
			height: '24px',
			flex: 'none',
			left: '-3px',
			position: 'relative',
		},
		'& span': {
			flex: 'none',
			padding: '0 8px',
			color: 'whiteOpacity.100',
			backgroundColor: 'secondary.500',
			borderRadius: '10em',
		},
	}),
	page1Label3: css({
		position: 'absolute',
		top: '88px',
		right: '15px',
		color: 'secondary.500',
		backgroundColor: 'white.1',
		borderRadius: '6px',
		padding: '3px 6px',
		fontWeight: '500',
		transformOrigin: 'right',
		transform: 'scale(0.71)',
		boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.38)',
		_before: {
			content: '""',
			position: 'absolute',
			top: '100%',
			right: '13px',
			borderColor: '{colors.white.1} transparent transparent transparent',
			borderWidth: '10px 5px 0px 5px',

		},
		md: {
			top: '100px',
		},
	}),
	page1Label4: css({
		position: 'absolute',
		bottom: '14px',
		left: '6px',
		fontSize: '12px',
		color: 'black.1',
		backgroundColor: 'white.1',
		border: '1px solid {colors.secondary.500}',
		borderRadius: '6px',
		padding: '6px',
		'& strong': {
			fontSize: '13px',
			fontWeight: '700',
		}
	}),
	page1Label5: css({
		display: 'none',
		position: 'absolute',
		top: '98px',
		left: '-5px',
		width: '120px',
		color: 'brand.500_light',
		fontWeight: '700',
		textAlign: 'center',
		transform: 'scale(0.42)',
		transformOrigin: 'center',
		md: {
			display: 'block',
		},
		_dark: {
			color: 'whiteOpacity.100',
		},
	}),

	page1Label4_payout: css({
		fontSize: '20px',
		fontWeight: '700',
		color: 'secondary.500',
	}),
	// Statement
	page2Label1: css({
		position: 'absolute',
		top: '44px',
		left: '36px',
		display: 'flex',
		transformOrigin: '0 0',
		transform: 'scale(0.75)',
		'& span': {
			flex: 'none',
			color: 'whiteOpacity.100',
		},
		'& svg': {
			flex: 'none',
			width: '16px',
			height: '16px',
			position: 'relative',
			left: '4px',
			top: '4px',
		},
	}),
	
	page2Label2: css({
		position: 'absolute',
		top: '70px',
		left: '0',
		width: '250px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		transformOrigin: 'center',
		transform: 'scale(0.42)',
		'& span': {
			flex: 'none',
			color: 'black.2',
			fontWeight: 'bold',
			// _dark: {
			// 	color: 'whiteOpacity.100',
			// },
		},
		'& svg': {
			flex: 'none',
			width: '24px',
			height: '24px',
			position: 'relative',
			top: '-1px',
			right: '6px',
		},
	}),

	page2Label3: css({
		position: 'absolute',
		top: '97px',
		left: '36px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	
	// Cash Out UUS $5.90
	page2Label4: css({
		position: 'absolute',
		top: '127px',
		left: '36px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	// Statement
	page2Label5: css({
		position: 'absolute',
		top: '170px',
		left: '40px',
		width: '165px',
		textAlign: 'center',
		color: 'whiteOpacity.100',
		fontWeight: '700',
		transform: 'scale(0.71)',
	}),
	page3Label1: css({
		position: 'absolute',
		top: '28px',
		left: '32px',
		display: 'flex',
		transformOrigin: '0 0',
		transform: 'scale(0.75)',
		'& span': {
			flex: 'none',
			color: 'whiteOpacity.100',
		},
		'& svg': {
			flex: 'none',
			width: '16px',
			height: '16px',
			position: 'relative',
			left: '4px',
			top: '4px',
		},
	}),
	page3Label2: css({
		position: 'absolute',
		top: '50px',
		left: '36px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),

	page3Label3: css({
		position: 'absolute',
		top: '79px',
		left: '36px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	
	// Cash Out UUS $5.90
	page3Label4: css({
		position: 'absolute',
		top: '109px',
		left: '36px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	page3Label5: css({
		position: 'absolute',
		top: '136px',
		left: '22px',
		width: '200px',
		display: 'flex',
		justifyContent: 'center',
		transformOrigin: 'center',
		transform: 'scale(0.42)',
		'& span': {
			flex: 'none',
			color: 'brand.500_light',
			fontWeight: '500',
		},
		'& svg': {
			width: '24px',
			height: '24px',
			flex: 'none',
			position: 'relative',
			left: '5px',
			
		},
	}),
	page3Label6: css({
		position: 'absolute',
		top: '156px',
		left: '12px',
		color: 'black.1',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	// Statement
	page3Label7: css({
		position: 'absolute',
		top: '187px',
		left: '40px',
		width: '165px',
		textAlign: 'center',
		color: 'whiteOpacity.100',
		fontWeight: '700',
		transform: 'scale(0.71)',
	}),
	page4Label1: css({
		position: 'absolute',
		top: '14px',
		left: '85px',
		display: 'flex',
		transformOrigin: '0 0',
		transform: 'scale(0.51)',
		'& span': {
			flex: 'none',
			color: 'whiteOpacity.100',
		},
		'& svg': {
			flex: 'none',
			width: '16px',
			height: '16px',
			position: 'relative',
			left: '4px',
			top: '4px',
		},
	}),
	page4Label2: css({
		position: 'absolute',
		top: '28px',
		left: '83px',
		color: 'black.1',
		transform: 'scale(0.45)',
		fontWeight: '700',
	}),
	// Your Cash Out has been accepted.
	page4Label3: css({
		position: 'absolute',
		top: '48px',
		left: '56px',
		width: '200px',
		display: 'flex',
		justifyContent: 'center',
		transformOrigin: 'center',
		transform: 'scale(0.42)',
		'& span': {
			flex: 'none',
			color: 'brand.500_light',
			fontWeight: '500',
		},
		'& svg': {
			width: '24px',
			height: '24px',
			flex: 'none',
			position: 'relative',
			left: '5px',
			
		},
	}),
	page4Label4: css({
		position: 'absolute',
		top: '69px',
		left: '85px',
		color: 'black.1',
		transformOrigin: '0 0',
		transform: 'scale(0.45)',
		fontWeight: '700',
	}),
	page4Label5: css({
		position: 'absolute',
		top: '95px',
		left: '85px',
		color: 'black.1',
		transformOrigin: '0 0',
		transform: 'scale(0.45)',
		fontWeight: '700',
	}),
	page4Label6: css({
		position: 'absolute',
		top: '143px',
		left: '151px',
		color: 'whiteOpacity.100',
		transformOrigin: '0 0',
		transform: 'scale(0.57)',
		fontWeight: '700',
	}),
	page4Label7: css({
		position: 'absolute',
		top: '155px',
		right: '12px',
		color: 'black.1',
		transformOrigin: 'right',
		transform: 'scale(0.34)',
		fontWeight: '400',
		'& strong': {
			color: 'secondary.500',
			fontWeight: '500',
			mr: '6px',
		},
	}),
	page4Label8: css({
		position: 'absolute',
		top: '110px',
		left: '22px',
		transformOrigin: '0 0',
		transform: 'scale(0.5)',
		fontWeight: '700',
		whiteSpace: 'nowrap',
	}),
	page4Label9: css({
		position: 'absolute',
		top: '126px',
		left: '22px',
		transformOrigin: '0 0',
		transform: 'scale(0.42)',
		fontWeight: '700',
		whiteSpace: 'nowrap',
	}),
	page4Label10: css({
		position: 'absolute',
		top: '149px',
		left: '22px',
		transformOrigin: '0 0',
		transform: 'scale(0.42)',
		fontWeight: '700',
		whiteSpace: 'nowrap',
	}),
	page4Label11: css({
		position: 'absolute',
		top: '172px',
		left: '22px',
		transformOrigin: '0 0',
		transform: 'scale(0.42)',
		fontWeight: '400',
	}),
	page4Label12: css({
		position: 'absolute',
		top: '196px',
		left: '12px',
		transformOrigin: '0 0',
		transform: 'scale(0.42)',
		fontWeight: '400',
	}),
	page4Label13: css({
		position: 'absolute',
		top: '196px',
		left: '72px',
		transformOrigin: '0 0',
		transform: 'scale(0.42)',
		fontWeight: '400',
	}),
}